<i18n lang='yml' src='../i18n/SubLocationForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4 v-if="type == 'edit'">
         {{ `${$t('update')} ${$t('sub_location')}`}}
        </h4> 
        <h4 v-else>
          {{ `${$t(type)} ${$t('sub_location')}`}}
        </h4>
      </div>
      <flash :message_type="message_type" :message_text="message_text"/>
        <h5 v-if="type == 'edit'" class="margin-top heading-page">
          <span>{{$t('update')}}</span>
          {{container_name}} - 

          <span v-if="subLocation">{{subLocation.name[locale]}}</span>
          <span>{{$t("details")}}</span>
        </h5>
        
        <Form ref="observer" v-slot="{ errors}" @submit="submitUserInput" @invalid-submit="setErrorMessage">
            <fieldset class="form-group border-bottom mt-4">
              <div class="row form-group">
                <div class="col-md-6 col-sm-4 col-xl-4">
                  <Field 
                    :name="$t('sub_location_id')"
                    rules="required|numeric" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.sub_location_id">
                    <label :for="$t('sub_location_id')"> 
                      {{$t('sub_location_id')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('sub_location_id')" 
                      name="sub_location_id"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="sub_location_id_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      {{ errors[0] }}
                    </div>
                  </Field> 
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('name_en')" 
                    rules="required" 
                    v-slot="{ errors, field, ariaMsg }"
                    v-model="subLocation.name.en">
                    <label for="name_en"> 
                      {{$t('name_en')}} 
                    </label>
                    <span class="red">*</span>
                    <input id="name_en" 
                      name="name_en"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="name_en_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span v-bind="ariaMsg" >{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('name_fr')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.name.fr">
                    <label :for="$t('name_fr')"> 
                      {{$t('name_fr')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('name_fr')" 
                      name="name_fr"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>             
              </div>
              <div class="row form-group">       
                <div class="col-12 col-md-9">
                  <Field 
                    :name="$t('street_address')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.street_address">
                    <label :for="$t('street_address')"> 
                      {{$t('street_address')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('street_address')" 
                      name="street_address"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="street_address_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>

              </div>
              <div class="row form-group">
                <div class="col-12 col-md-6">
                  <Field 
                    :name="$t('city')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.city">
                    <label :for="$t('city')"> 
                      {{$t('city')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('city')" 
                      name="city"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="city_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>
              </div>
              <div class="row form-group">
                <div class="col-12 col-sm-8 col-md-5 col-xl-4">
                  <Field 
                    :name="$t('province')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.province">
                    <label :for="$t('province')"> 
                      {{$t('province')}} 
                    </label>
                    <span class="red">*</span>
                    <select 
                      v-bind="field" 
                      :id="subLocation.province" 
                      class="form-control"
                      :class="{'is-invalid': errors[0]}">
                      <option v-for="province in provinces" :key="province.label" :value="province.label">
                        {{$t(`provinces.${province.label}`)}}
                      </option>
                    </select>
            
                    <div class="invalid-feedback" id="province_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field>   
                </div>
              </div>      
              <div class="row form-group">
                <div class="col-6 col-xl-4">
                  <Field 
                    :name="$t('postal_code')"
                    :rules="{required: true, regex: ['postal_code', $t('postal_code').toLowerCase()]}"
                    v-slot="{ errors, field }"
                    v-model="subLocation.postal_code">
                    <label :for="$t('postal_code')"> 
                      {{$t('postal_code')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('postal_code')" 
                      name="postal_code"
                      class="form-control" 
                      @input="postalFormat" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field"
                      type="text">
                    <div class="invalid-feedback" id="postal_code_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>
              </div>
              <div class="row form-group">
                <div class="col-7 col-sm-8 col-md-6">
                  <Field 
                    :name="$t('phone_number')" 
                    :rules="{required: true, regex: ['phone', $t('phone_number').toLowerCase()]}"
                    v-slot="{ errors, field }"
                    v-model="subLocation.phone_number">
                    <label :for="$t('phone_number')"> 
                      {{$t('phone_number')}} 
                    </label>
                    <span class="red">*</span>
                    <input name="phone_number" 
                    type="text" 
                    :id="$t('phone_number')"
                    class="form-control"   
                    :class="{'is-invalid': errors[0]}" 
                    @input="phoneFormat"
                    v-bind="field">
                    <div class="invalid-feedback" id="phone_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>
                <div class="col-5 col-sm-4 number-hide-increment">
                  <label for="phone_number_extension"> {{$t('label_ext')}} </label>
                  <input type="number" id="phone_number_extension" name="phone_number_extension"  min="0" class="form-control small-form-control"  v-model="subLocation.phone_number_extension">
                </div>
              </div>
              <div class="row form-group">
                <div class="col-12 col-md-4 col-md-5">
                  <Field 
                    :name="$t('email')"
                    :rules="{required: true, regex: ['email', $t('email').toLowerCase()]}"
                    v-slot="{ errors, field }"
                    v-model="subLocation.email">
                    <label :for="$t('email')"> 
                      {{$t('email')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('email')" 
                      name="email"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="email_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field> 
                </div>
              </div>
              <div class="row form-group">
                <div class="col-12 col-md-5">
                  <Field 
                    :name="$t('contact')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.contact">
                    <label :for="$t('contact')"> 
                      {{$t('contact')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('contact')" 
                      name="contact"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="contact_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field>  
                </div>
              </div>
              <div class="row form-group">
                <div class="col-12 col-sm-7 col-md-5 col-xl-4">
                  <Field 
                    :name="$t('max_seats')"
                    rules="required|greater_than_zero|numeric" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.max_seats">
                    <label :for="$t('max_seats')"> 
                      {{$t('max_seats')}} 
                    </label>
                    <span class="red">*</span>
                    <input 
                      :id="$t('max_seats')"
                      name="max_seats" 
                      type="number" 
                      class="form-control small-form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field">          
                      <div class="invalid-feedback" id="max_seats_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                  </Field>
                </div>
              </div>

              <div class="form-group">
                <label :for="$t('private_room_available')">
                  {{$t('private_room_available')}}
                </label>
                <span class="red">*</span>
                <div class="col-sm-6" id="private_booth_available">
                  <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('private_room_available')]}">
                    <label class="form-check-label">
                      <Field
                        :name="$t('private_room_available')"
                        rules="required"
                        v-model="subLocation.exam_booth_available"
                        :id="`${$t('private_booth_available')}_true`" 
                        :aria-checked="`${$t('private_booth_available')}_true`" 
                        value=true 
                        type="radio"/>
                      {{$t('yes_val')}}
                    </label>

                  </div>
                  <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('private_room_available')]}">
                    <label class="form-check-label">
                      <Field
                        :name="$t('private_room_available')"
                        rules="required"                
                        v-model="subLocation.exam_booth_available"
                        :id="`${$t('private_booth_available')}_false`" 
                        :aria-checked="`${$t('private_booth_available')}_false`" 
                        value=false 
                        type="radio"/>
                      {{$t('no_val')}}
                    </label>
                  </div>
                  <div class="invalid-feedback" id="private_booth_available_error" v-if="errors[$t('private_room_available')]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    {{ errors[$t('private_room_available')]}}
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-12 col-md-6">
                  <Field 
                    :name="$t('available_languages')"
                    rules="required"
                    v-slot="{ errors, field }"
                    v-model="selectedLanguages">
                    <label :for="$t('available_languages')"> {{$t('available_languages')}} </label>
                    <span class="red">*</span>
                    <multi-select
                      id="available_languages"
                      name="available_languages"
                      :class="{'is-invalid': errors[0]}"
                      v-model="selectedLanguages"
                      v-bind="field"
                      :options="[{ label: $t('english'), value: 'English' }, { label: $t('french'), value: 'French' }]"
                      label="label"
                      value-prop="value"
                      mode="tags"
                      :hideSelected="false"
                      :create-option="false"
                      :canClear="true"
                    />
                    <div class="invalid-feedback" id="available_languages_errors" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field>   
                </div>
              </div>
              <div class="form-group">
                <label for="additional_information"> {{$t('additional_information')}} </label>
                <textarea id="additional_information" name="additional_information" rows="6" class="form-control" v-model="subLocation.additional_instructions" maxlength="600"/>
              </div>
              <div class="form-group">
                <label for="additional_information_fr"> {{$t('additional_information_fr')}} </label>
                <textarea id="additional_information_fr" name="additional_information_fr" rows="6" class="form-control" v-model="subLocation.additional_instructions_fr" maxlength="600"/>
              </div>
              <div class="form-group row">
                <div class="col-12 col-sm-8 col-md-5 col-xl-4">
                  <Field 
                    :name="$t('status')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="subLocation.status">
                    <label :for="$t('status')"> 
                      {{$t('status')}} 
                    </label>
                    <span class="red">*</span>
                    <select 
                      v-bind="field" 
                      :id="subLocation.status" 
                      class="form-control"
                      :disabled="type == 'new'"
                      :class="{'is-invalid': errors[0]}"
                      >
                      <option v-for="status in statusData" :key="status.label" :value="status.label">
                        {{$t(`${status.label}`)}}
                      </option>
                    </select>
            
                    <div class="invalid-feedback" id="provincee_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span> 
                    </div>
                  </Field>   
                </div>
              </div> 
            </fieldset>

            <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
              <span class="red mr-2">
                <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
              </span>
              {{ $t('error_warning') }}
            </div>
          
            <div class="btn-row d-flex">
              <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="type=='new'">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('create') }}
              </button>
              <template v-else>
                <button  type="submit" class="btn btn-primary btn-success no-shadow">
                  <font-awesome-icon :icon="['fa', 'save']" />
                  {{ $t('submit') }}
                </button>
                <a class="btn btn-danger" v-if="!hide_delete" :data-confirm="$t('confirm_delete')" data-method="delete" :href="`${base_path}/${subLocation.id}`">
                  <font-awesome-icon :icon="['fa', 'trash-alt']" />
                  {{ $t('delete_sub_location') }}
                </a>
              </template>
                <a class="btn btn-light ml-auto" :href="base_path">
                <font-awesome-icon :icon="['fa', 'times']" />
                {{ $t('cancel') }}
              </a>
            </div>
        </Form>
    </div>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue'  
  import '../../../javascripts/application/vee-validate-rules'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../shared/typescripts/ajax.ts'
  import { setErrorMessage } from '../../shared/typescripts/error.ts'

  import { Form, Field } from 'vee-validate'
  export default {
    props: ['locale', 'base_path', 'type', 'statuses', 'sub_location', 'container_name', 'hide_delete'],

    components: {
      flash,
      Form,
      Field
    },

    data() {
      return {
        subLocation: {
          name: {},
          sub_location_id: null,
          available_languages: null,
          street_address: null,
          city: null,
          province: null,
          phone_number: null,
          phone_number_extension: null,
          email: null,
          contact: null,
          addition_instructions: null,
          max_seats: null,
          status: 'pending',
          exam_booth_available: null,
          additional_instructions_fr: null,
        },
        loading: false,
        error: false,
        filterParams: null,
        message_type: "",
        message_text: [],
        availableLanguages: [],
        statusData: [],
        provinces: [
          {id: 0, label: 'ontario'},
          {id: 1, label: 'alberta'},
          {id: 2, label: 'british_columbia'},
          {id: 3, label: 'manitoba'},
          {id: 4, label: 'new_brunswick'},
          {id: 5, label: 'newfoundland'},
          {id: 6, label: 'northwest_territories'},
          {id: 7, label: 'nova_scotia'},
          {id: 8, label: 'nunavut'},
          {id: 9, label: 'pei'},
          {id: 10, label: 'quebec'},
          {id: 11, label: 'saskatchewan'},          
          {id: 12, label: 'yukon'}
        ],
        showErrorBanner: false,
        ariaInput: "",
        ariaMsg: "",
        selectedLanguages: [],
      }
    },

    created(){
      this.$i18n.locale = this.locale;
    },
    
    mounted() {
      try{
        this.statusData = JSON.parse(this.statuses)
        if(this.sub_location){
          this.subLocation = JSON.parse(this.sub_location)
        }
        
      }
      catch(err) {
        this.error = true; 
      }
      this.fetchSelectedLanguages()
      this.examBoothAvailableString()
    },

    methods: {
      fetchSelectedLanguages() {
        if(this.subLocation.available_languages) {
          this.selectedLanguages = this.subLocation.available_languages.split(', ')
        }
      },

      examBoothAvailableString() {
        if (this.subLocation.exam_booth_available != null) {
          return this.subLocation.exam_booth_available = this.subLocation.exam_booth_available.toString();
        }
      },

      phoneFormat(input) {
          let formattedInput = input.target.value.replace(/\D/g,'');
          var size = formattedInput.length;
          if (size>0) {formattedInput="("+formattedInput}
          if (size>3) {formattedInput=formattedInput.slice(0,4)+") "+formattedInput.slice(4,11)}
          if (size>6) {formattedInput=formattedInput.slice(0,9)+"-" +formattedInput.slice(9)}
          input.target.value = formattedInput
      },

      postalFormat(input) {
        let formattedInput = input.target.value.toUpperCase().replace(/\W/g,'')
        if (formattedInput.length>3) {
          formattedInput=formattedInput.slice(0,3)+" "+formattedInput.slice(3,6)
        }
        input.target.value = formattedInput;
      },


      submitUserInput(event){
        let payload = []
        this.subLocation.available_languages = this.selectedLanguages.join(', ')
        payload = { sub_location: this.subLocation} 
        this.message_text = [];
        let send_type = 'POST'
        let path = this.base_path

        if (this.type == "edit") {
          send_type = "PUT"
          path = `${this.base_path}/${this.subLocation.id}`
        }

        sendAjaxRequest(send_type, path, 'json', payload, ajaxResponseMessage, this.throwError)
      },

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      },

      throwError(){
        console.log("Error")
      }

    }
  }
</script>
